import './company-verification-status.scss';
import { useMemo } from 'react';
import cn from 'classnames';

interface ICompanyVerificationStatus {
  verified: boolean;
}

export default function CompanyVerificationStatus({
  verified,
}: ICompanyVerificationStatus) {
  const [statusText, statusClass] = useMemo(() => {
    switch (verified) {
      case true:
        return ['Подтверждена', 'company-verification-status_green'];
      default:
        return ['Ожидание подтверждения', 'company-verification-status_yellow'];
    }
  }, [verified]);
  return (
    <div className={cn('company-verification-status', statusClass)}>
      {statusText}
    </div>
  );
}
